/**
 * Created by A665445 on 09/05/2017.
 */
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { LicenceToMaster } from './licence-to-master.model';

@Injectable()
export class LicenceToMasterService {

    private resourceUrl = 'api/licence-to-masters';

    constructor(private http: Http) { }

    query(): Observable<LicenceToMaster[]> {
        return this.http.get(this.resourceUrl).map((res: any) => res.json() as LicenceToMaster[]);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/licence-to-master.service.ts